import type { PropsWithChildren } from 'react';

export const HeaderSmall = ({ children }: PropsWithChildren) => (
  <h6 className="text-headline-sm mb-md mb-5 font-semibold leading-tight">
    {children}
  </h6>
);

HeaderSmall.displayName = 'HeaderSmall';
